/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const ContactUsForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText = null,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="contact-us-form"
      onSubmit={(e) => processForm(e, '', 'departmentToContact', captchaRef)}
    >
      <h3>First Name *</h3>
      <input
        name="firstName"
        id="firstName"
        className="form-control"
        type="text"
        required
      />

      <h3>Last Name *</h3>
      <input
        name="lastName"
        id="lastName"
        className="form-control"
        type="text"
        required
      />

      <h3>Phone *</h3>
      <input
        name="phoneNumber"
        id="phoneNumber"
        className="form-control"
        type="tel"
        required
      />

      <h3>Email address *</h3>
      <input
        name="email"
        id="email"
        className="form-control"
        type="email"
        required
      />

      <h3>Department to contact *</h3>
      <select
        name="departmentToContact"
        id="department"
        className="form-control"
        required
      >
        <option>--- Choose a Department ---</option>
        <option value="b4df7ef44c13">Guest Feedback</option>
        <option value="68100a1f8a22">Lodging</option>
        <option value="18b052dd6407">Season Pass Office</option>
        <option value="cb1e1032f064">
          Groups and Conferences
        </option>
        <option value="eb05cc9c4532">Employment</option>
        <option value="1d9552843f50">Lost and Found</option>
      </select>

      <h3>Message *</h3>
      <textarea name="message" id="message" rows="9" cols="33" required />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

ContactUsForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
